import {gql} from '@apollo/client';

import {Note, NoteAcknowledgement} from '../queries';

export const CreateNoteQuery = gql`
    mutation CreateNoteQuery(
        $childId: ChildId!
        $sensitive: Boolean!
        $parentVisible: Boolean!
        $imageIds: [ImageId!]
        $fileIds: [FileId!]
        $text: String
        $sendNotification: Boolean
        $safeguardingConcern: Boolean
        $noteType: ChildNoteType
        $publish: Boolean
    ) {
        children {
            createChildNote(
                childId: $childId
                sensitive: $sensitive
                parentVisible: $parentVisible
                imageIds: $imageIds
                fileIds: $fileIds
                text: $text
                sendNotification: $sendNotification
                safeguardingConcern: $safeguardingConcern
                noteType: $noteType
                publish: $publish
            ) {
                ...Note
            }
        }
    }
    ${Note}
`;

export const UpdateNoteQuery = gql`
    mutation UpdateNoteQuery(
        $noteId: ChildNoteId!
        $sensitive: Boolean!
        $parentVisible: Boolean!
        $imageIds: [ImageId!]
        $fileIds: [FileId!]
        $text: String
        $sendNotification: Boolean
        $safeguardingConcern: Boolean
        $publish: Boolean
    ) {
        children {
            updateChildNote(
                noteId: $noteId
                sensitive: $sensitive
                parentVisible: $parentVisible
                imageIds: $imageIds
                fileIds: $fileIds
                text: $text
                sendNotification: $sendNotification
                safeguardingConcern: $safeguardingConcern
                publish: $publish
            ) {
                ...Note
            }
        }
    }
    ${Note}
`;

export const DeleteNoteQuery = gql`
    mutation DeleteNoteQuery($noteId: ChildNoteId!) {
        children {
            deleteChildNote(noteId: $noteId)
        }
    }
`;

export const AcknowledgeNote = gql`
    mutation AcknowledgeNote($noteId: ChildNoteId!, $signedAs: SignedAs!) {
        children {
            acknowledge(childNoteId: $noteId, signedAs: $signedAs) {
                ...NoteAcknowledgement
            }
        }
    }
    ${NoteAcknowledgement}
`;
